import { useState } from "react";

import generateUniqueId from "./generateUniqueId";

export default function useUniqueId(id, prefix) {
  const [defaultId] = useState(
    () => `${prefix ? prefix + "-" : ""}${generateUniqueId()}`,
  );
  return id ?? defaultId;
}
